import type { DeploymentActionResource } from "@octopusdeploy/octopus-server-client";
import { getBlueprintIdFromAction } from "~/areas/projects/components/Process/Blueprints/blueprintId";
import { client, repository } from "~/clientInstance";
export default function getActionLogoUrl(action: DeploymentActionResource | null) {
    if (!action || !action.Properties) {
        return "";
    }
    const templateId = action.Properties["Octopus.Action.Template.Id"];
    const version = action.Properties["Octopus.Action.Template.Version"];
    const stepPackageVersion = action.StepPackageVersion;
    if (action.ActionType === "Octopus.Blueprint" && repository.spaceId) {
        const blueprintId = getBlueprintIdFromAction(action, true);
        if (blueprintId) {
            return `~/bff/spaces/${repository.spaceId}/blueprints/${blueprintId}/icon`;
        }
    }
    if (stepPackageVersion !== undefined) {
        const majorVersion = stepPackageVersion.split(".")[0];
        return client.resolveLinkTemplate("ActionTemplateVersionedLogo", { typeOrId: action.ActionType, version: majorVersion });
    }
    return templateId ? client.resolveLinkTemplate("ActionTemplateVersionedLogo", { typeOrId: templateId, version }) : client.resolveLinkTemplate("ActionTemplateLogo", { typeOrId: action.ActionType });
}
